import { allDocs } from "content-collections";
import i18n from "@/i18n";

function getLanguageSuffix(language: string) {
  const short = language.split('-')[0];
  return short === 'hu' ? '' : `.${short}`;
}

export function useGetDocs(docs?: string) {
  const suffix = getLanguageSuffix(i18n.language);

  if (!docs) return null;

  const found = allDocs.find((doc) => doc._meta.path === `${docs}${suffix}`);
  return found;
}
